import { combineReducers } from 'redux';
import { downloadsReducer } from 'features/worker/reducer/downloadsSlice';

export default combineReducers({
  downloads: downloadsReducer,
});
